import React from "react";
import { Button, Box, Typography, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const ElasticSearch = (props) => {
    const { index_name, analytics_panel_id } = props;
    const [opengrafana, setOpengrafana] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const timeoutRef = React.useRef(null);

    const handleClickOpenGrafana = () => {
        setOpengrafana(true);
        setLoading(true);
        setError(false);
        
        // Set timeout for unresponsive iframe
        timeoutRef.current = setTimeout(() => {
            if (loading) {
                setError(true);
                setLoading(false);
            }
        }, 10000); // 10 seconds timeout
    };

    const handleCloseGrafana = () => {
        setOpengrafana(false);
        clearTimeout(timeoutRef.current);
    };

    const handleIframeLoad = () => {
        clearTimeout(timeoutRef.current);
        setLoading(false);
    };

    const handleIframeError = () => {
        clearTimeout(timeoutRef.current);
        setError(true);
        setLoading(false);
    };

    const grafanadomain = `${process.env.REACT_APP_GRAFANA_URL}/d/`;
    const org = "?orgId=1";
    const kiosk = "&kiosk";
    const grafanapanelurl = `${grafanadomain}${analytics_panel_id}${org}${kiosk}`;

    return (
        <>
            <Tooltip title="View Report" arrow>
                <Button
                    onClick={handleClickOpenGrafana}
                    variant="contained"
                    color="primary"
                    aria-label="view report"
                    sx={{
                        mx: 1,
                        width: { xs: '75px', sm: '85px' },
                        height: { xs: '23px', sm: '25px' },
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    }}
                >
                    Report
                </Button>
            </Tooltip>
            
            <Dialog
                open={opengrafana}
                onClose={handleCloseGrafana}
                aria-labelledby="alert-dialog-title"
                maxWidth='lg'
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{`ServerName: ${index_name || 'N/A'}`}</DialogTitle>
                <DialogContent>
                    <Box sx={{ minHeight: '500px' }}>
                        {loading && !error && (
                            <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                                <Typography>Loading report...</Typography>
                            </Box>
                        )}
                        
                        {error ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                                <Typography color="error">
                                    Data not accessible at this time. Please try again later.
                                </Typography>
                            </Box>
                        ) : (
                            <iframe 
                                src={grafanapanelurl}
                                width="100%"
                                height="500"
                                frameBorder="0"
                                onLoad={handleIframeLoad}
                                onError={handleIframeError}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Close" arrow>
                        <Button
                            onClick={handleCloseGrafana}
                            color="primary"
                            autoFocus
                            sx={{
                                borderRadius: '50px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                px: 3,
                            }}
                        >
                            Close
                        </Button>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ElasticSearch;